import { useState } from "react";
import { motion } from "framer-motion";
import { ShieldAlert, Send } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { fadeInUp, transition } from "@/utils/motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BlockedView = ({ blockedInfo, email, onBack }) => {
  const [appealMessage, setAppealMessage] = useState("");
  const [appealSent, setAppealSent] = useState(false);

  const handleAppeal = async () => {
    if (appealMessage.trim().length < 10) {
      toast.error("Please write at least 10 characters");
      return;
    }
    try {
      await axios.post(`${API}/auth/appeal`, {
        email: blockedInfo?.email || email,
        message: appealMessage.trim(),
      });
      setAppealSent(true);
      toast.success("Appeal submitted");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to submit appeal");
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="blocked-page">
      <motion.div {...fadeInUp} transition={transition} className="hud-card clip-corners p-8 border border-yellow-500/50">
        <div className="flex items-center gap-3 mb-4">
          <ShieldAlert className="h-8 w-8 text-yellow-400" />
          <h1 className="font-headings text-2xl uppercase tracking-widest text-yellow-400" data-testid="blocked-title">Account Blocked</h1>
        </div>
        <div className="border border-yellow-500/30 bg-yellow-500/5 p-4 mb-6">
          <p className="text-xs uppercase tracking-widest text-gray-500 mb-1">Reason</p>
          <p className="text-sm text-yellow-300" data-testid="blocked-reason">{blockedInfo.reason}</p>
        </div>
        {appealSent ? (
          <div className="text-center py-4" data-testid="appeal-sent">
            <p className="text-sm text-green-400 mb-2">Your appeal has been submitted.</p>
            <p className="text-xs text-gray-400">An admin will review it. Check back later.</p>
          </div>
        ) : (
          <div data-testid="appeal-form">
            <h3 className="font-headings text-sm uppercase tracking-widest text-white mb-3">
              <Send className="inline h-3 w-3 mr-1" /> Request Unblock
            </h3>
            <textarea
              value={appealMessage}
              onChange={(e) => setAppealMessage(e.target.value.slice(0, 500))}
              placeholder="Explain why you believe this block should be lifted..."
              className="w-full bg-black/50 border border-white/20 text-white font-data text-sm py-2 px-3 h-24 focus:border-yellow-500 outline-none resize-none"
              data-testid="appeal-message"
            />
            <p className="text-xs text-gray-500 mt-1">{appealMessage.length}/500</p>
            <button
              onClick={handleAppeal}
              disabled={appealMessage.trim().length < 10}
              className="mt-3 w-full bg-yellow-500 text-black font-headings uppercase tracking-widest py-3 hover:bg-yellow-400 disabled:opacity-40"
              data-testid="appeal-submit"
            >
              Submit Appeal
            </button>
          </div>
        )}
        <button onClick={onBack} className="mt-4 w-full border border-white/10 py-2 text-xs font-data text-gray-400 hover:text-white" data-testid="blocked-back">
          Back to login
        </button>
      </motion.div>
    </div>
  );
};

export default BlockedView;
